/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Icon, Popup } from 'semantic-ui-react';
import { useTextResources } from '../../language';

export const IconButton = ({ onClick, children, content, style = {}, ...rest }) => {
  const text = useTextResources();

  return (
    <Popup
      content={text(content)}
      trigger={
        <Button
          onClick={onClick}
          icon
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            boxShadow: 'none',
            ...style
          }}
          {...rest}
        >
          {children}
        </Button>
      }
    />
  );
};

export const TrashButton = (props) => {
  return (
    <IconButton content={props?.content || 'Remove'} {...props}>
      <Icon link name='trash' />
    </IconButton>
  );
};

export const EditButton = (props) => {
  return (
    <IconButton content={props?.content || 'Edit'} {...props}>
      <Icon link name='pencil' />
    </IconButton>
  );
};

export const PercentButton = (props) => {
  return (
    <IconButton content={props?.content || 'Percent'} {...props}>
      <Icon link name='percent' />
    </IconButton>
  );
};

export const RegisterButton = (props) => {
  return (
    <IconButton content={props?.content || 'Register'} {...props}>
      <Icon link name='sign-in' />
    </IconButton>
  );
};

export const EyeButton = (props) => {
  return (
    <IconButton content={props?.content || 'Show password'} {...props}>
      <Icon link name='eye' />
    </IconButton>
  );
};

export const EyeOffButton = (props) => {
  return (
    <IconButton content={props?.content || 'Hide password'} {...props}>
      <Icon link name='eye slash' />
    </IconButton>
  );
};
